import { FormControl, Stack, FormLabel, Switch, Box } from '@chakra-ui/react';
import {
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';
import CountryFlag from 'components/icons/CountryFlag';
import { PlatformEnums } from '@/utils/platforms';

const UserPlatformControl = ({
    submitData,
    setPlatformUser,
    errors,
    touched,
    darkMode,
    section,
    platformID,
}) => {
    const platformIndex = submitData.findIndex(
        (platform) => platform.platformID === platformID,
    );

    const platform = submitData[platformIndex];

    // managedBy: 0 means TCAP is managing the platform
    // managedBy: 1 means the Other is managing the platform
    const handleChange = (e) => {
        const { checked } = e.target;
        setPlatformUser((prev) => {
            const newPlatforms = [...prev];
            newPlatforms[platformIndex] = {
                ...platform,
                managedBy: checked ? 0 : 1,
            };
            return newPlatforms;
        });
    };

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={
                !!errors[`${section}-managedBy`] &&
                touched[errors[`${section}-managedBy`]]
            }>
            <Stack
                direction="row"
                height="35px"
                sx={stackStyling()}
                justify="space-between">
                <Stack direction="row" spacing={1}>
                    <FormLabel
                        sx={{
                            ...formLabelStyling(darkMode),
                            minWidth: '150px',
                        }}>
                        Managed By TCAP
                    </FormLabel>
                    <Switch
                        paddingLeft={1}
                        paddingTop="22px"
                        paddingRight="7px"
                        name="managedBy"
                        onChange={handleChange}
                        isChecked={platform?.managedBy === 0}
                        data-walkthroughid={walkthroughIds.edit.ufManagedBtn}
                    />
                </Stack>
                {platformID === PlatformEnums.TEAMS && (
                    <Stack direction="row" justify="flex-end" minWidth="200px">
                        <FormLabel
                            sx={{
                                ...formLabelStyling(darkMode),
                                minWidth: '100px',
                            }}>
                            Usage Location
                        </FormLabel>
                        <Box paddingTop="15px" minWidth="122px">
                            <CountryFlag
                                countryCode={platform?.usageLocation}
                            />
                        </Box>
                    </Stack>
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformControl;
